import type { Prototype } from "../prototype-types";

export const tomMaPrototypes: Prototype[] = [
  {
    id: "tma-asset-creation",
    name: "Asset creation",
    path: "/tma/asset-creation",
    description:
      "Step-by-step flow for creating Discovery Surface ad assets — banners, new collections, seasonal promotions, and videos — plus an AI-guided chat that builds a creative from your logo, library assets, and catalog with a live banner/tile preview, switchable from the toolbar.",
    owner: "Tom Ma",
    createdAt: "2026-10-07",
    lastUpdated: "2026-10-08",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "cursor",
    thumbnail: "/images/thumbnails/tma-asset-creation.png",
  },
];
